(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
class CustomFaqNav extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onLinkClick);

    this.links = Array.from(this.querySelectorAll('.custom-faq__nav-link'));
    this.categories = this.links
      .map((link) => ({ link, target: document.getElementById(link.dataset.target) }))
      .filter((item) => item.target?.classList.contains('custom-faq__category'));

    if (this.categories.length) {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onLinkClick);
    window.removeEventListener('scroll', this.onScroll);
  }

  setActive = (link) => {
    this.links.forEach((item) => item.classList.toggle('is-active', item === link));
  };

  onScroll = () => {
    if (this.tickingScroll) return;
    this.tickingScroll = true;

    requestAnimationFrame(() => {
      this.tickingScroll = false;

      // A category is "current" once it has crossed the vertical middle of the
      // viewport, not merely the moment it clears the header — matches how the
      // reveal reads while scrolling past a tall category body.
      const offset = window.innerHeight / 2;
      let active = this.links[0];

      this.categories.forEach(({ link, target }) => {
        if (target.getBoundingClientRect().top - offset <= 0) {
          active = link;
        }
      });

      this.setActive(active);
    });
  };

  onLinkClick = (event) => {
    const link = event.target.closest('.custom-faq__nav-link');
    if (!link) return;

    const target = document.getElementById(link.dataset.target);
    if (!target) return;

    this.setActive(link);
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
}

if (!customElements.get('custom-faq-nav')) {
  customElements.define('custom-faq-nav', CustomFaqNav);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('quick-view-popup')) {
    class QuickViewPopup extends HTMLElement {
      constructor() {
        super();

        this.cache = new Map();
        this.variantCache = new Map();
        this.isOpen = false;
        this.photoSwipeReady = null;
      }

      connectedCallback() {
        this.dialog = this.querySelector('.quick-view-popup__dialog');
        this.panel = this.querySelector('.quick-view-popup__body');

        this.addEventListener('click', this.onCloseClick);
        document.addEventListener('keydown', this.onKeydown);
        window.addEventListener('resize', this.onViewportChange);

        // Capture phase: the theme's quick cart drawer binds its own click handler on
        // the very same trigger in the bubble phase, so stopping propagation up here is
        // what keeps the two from both opening. Nothing in the theme is patched.
        if (this.dataset.mode === 'popup') {
          document.addEventListener('click', this.onTriggerClick, true);
        }

        // The theme deletes .quick-cart-drawer__trigger from every product card when
        // <quick-cart-drawer> is absent (assets/global.js), and that trigger is the card's
        // buy button. Nothing here can undo it — the cards are upgraded before this
        // element connects — so say plainly why the buttons went missing.
        if (this.dataset.mode === 'popup' && !document.querySelector('quick-cart-drawer')) {
          console.warn(
            '[quick-view] The "Quick add to cart drawer" section is switched off. The theme ' +
              'strips the quick add button from every product card while it is missing, so the ' +
              'popup has nothing to open. Re-enable it in the Overlay group and leave it on: the ' +
              'popup suppresses it, so it never opens on its own.'
          );
        }

        if (window.Shopify && Shopify.designMode) {
          this.parentElement.addEventListener('shopify:section:select', this.onSectionSelect);
          this.parentElement.addEventListener('shopify:section:deselect', this.onSectionDeselect);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onTriggerClick, true);
        document.removeEventListener('keydown', this.onKeydown);
        window.removeEventListener('resize', this.onViewportChange);
        this.removeEventListener('click', this.onCloseClick);

        if (window.Shopify && Shopify.designMode && this.parentElement) {
          this.parentElement.removeEventListener('shopify:section:select', this.onSectionSelect);
          this.parentElement.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
        }

        clearTimeout(this.unmountTimer);
        clearTimeout(this.variantRefreshTimer);
        this.teardownContent();
        document.body.classList.remove('overflow-hidden');
      }

      /* ── Triggers ──────────────────────────────────────────────────────── */

      onTriggerClick = event => {
        const trigger = event.target.closest('.quick-cart-drawer__trigger');
        if (!trigger || trigger.disabled) return;

        const productUrl = trigger.dataset.productUrl;
        if (!productUrl) return;

        event.preventDefault();
        event.stopPropagation();

        this.load(trigger, productUrl);
      };

      onCloseClick = event => {
        if (event.target.closest('[data-quick-view-close]')) this.close();
      };

      onKeydown = event => {
        if (!this.isOpen) return;

        if (event.key === 'Escape') {
          this.close();
          return;
        }

        if (event.key === 'Tab') this.trapFocus(event);
      };

      // Selecting the section in the theme editor used to open an empty dialog. Load the
      // first product on the page instead so the merchant sees what they are styling, and
      // stay shut when the page has no quick add trigger to borrow a product from.
      onSectionSelect = () => {
        if (this.panel.childElementCount) {
          this.open();
          return;
        }

        const trigger = document.querySelector('.quick-cart-drawer__trigger[data-product-url]');
        if (trigger) this.load(trigger, trigger.dataset.productUrl);
      };

      onSectionDeselect = () => this.close();

      /* ── Load ──────────────────────────────────────────────────────────── */

      async load(trigger, productUrl) {
        trigger.classList.add('is--loading');
        this.classList.add('is--loading');

        try {
          const [html] = await Promise.all([this.fetchProduct(productUrl), this.loadProductStyles()]);

          this.teardownContent();
          this.productUrl = productUrl;
          this.classList.add('is--rendered');
          this.panel.innerHTML = html;
          this.initContent(trigger);
          this.open();
        } catch (error) {
          // A failed quick view must not swallow the click: send the shopper to the
          // product page, which is where the popup was a shortcut to anyway.
          console.error('[quick-view]', error);
          if (!this.isOpen) this.classList.remove('is--rendered');
          if (!(window.Shopify && Shopify.designMode)) window.location.href = productUrl;
        } finally {
          trigger.classList.remove('is--loading');
          this.classList.remove('is--loading');
        }
      }

      // The remembered section id belongs to one theme's product template. Restarting
      // `shopify theme dev` mints a new development theme, which makes the stored id
      // answer 404 for every open — so a failure drops it and retries against the full
      // page, which is also how the id is discovered in the first place.
      async fetchProduct(productUrl) {
        if (this.cache.has(productUrl)) return this.cache.get(productUrl);

        try {
          return await this.requestProduct(productUrl);
        } catch (error) {
          if (!this.resolvedSectionId()) throw error;

          console.warn('[quick-view] stale section id, retrying without it', error);
          this.forgetSectionId();

          return this.requestProduct(productUrl);
        }
      }

      async requestProduct(productUrl) {
        const response = await fetch(`${this.viewUrl(productUrl)}`);
        if (!response.ok) throw new Error(`${response.status} for ${productUrl}`);

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

        // A section in a JSON template is wrapped as shopify-section-template--<id>__<key>,
        // so the key can only be matched on the suffix. Matching on it also keeps this from
        // grabbing the popup's own shell, which a full-page response carries too.
        // Widening order: the template's own key, then either section by class, then any
        // section belonging to a template — a theme whose key is not `main` still works.
        const markup =
          doc.querySelector(`[id$="__${this.sectionKey}"]`) ||
          doc.querySelector('.quick-view, .main-product') ||
          doc.querySelector('[id^="shopify-section-template--"]');

        if (!markup) throw new Error(`no section found in the response for ${productUrl}`);

        this.rememberSectionId(markup.id.replace('shopify-section-', ''));
        this.prepareMarkup(markup);

        const html = markup.outerHTML;
        this.cache.set(productUrl, html);

        return html;
      }

      // The popup reuses the product page's own classes (.product-detail-row,
      // .product-block-reviews, the Judge.me badge), and custom-product.css is where they
      // are styled. Pulled once, on the first open.
      loadProductStyles() {
        if (this.productStylesReady) return this.productStylesReady;

        this.productStylesReady = this.loadAsset('link', this.dataset.productCss).catch(error => {
          console.error('[quick-view]', error);
        });

        return this.productStylesReady;
      }

      // Only the fully qualified section id — template--<id>__<key> — makes the Section
      // Rendering API return the section WITH the blocks and settings saved in the
      // template. The bare key answers 404 and the file name renders the section
      // standalone: schema defaults, no blocks. That id belongs to the product template,
      // so this section cannot know it; it is read once from a full-page response and
      // remembered, which turns every later open into ~25 KB instead of ~300 KB.
      viewUrl(productUrl, params = '') {
        const sectionId = this.resolvedSectionId();
        const section = sectionId ? `&section_id=${encodeURIComponent(sectionId)}` : '';

        return `${this.localePrefix()}${productUrl}?view=quick-view${section}${params}`;
      }

      get sectionKey() {
        return this.dataset.sectionId || 'main';
      }

      resolvedSectionId() {
        if (this.renderSectionId) return this.renderSectionId;

        try {
          this.renderSectionId = sessionStorage.getItem(`quick-view:${this.sectionKey}`) || null;
        } catch (error) {
          this.renderSectionId = null;
        }

        return this.renderSectionId;
      }

      forgetSectionId() {
        this.renderSectionId = null;

        try {
          sessionStorage.removeItem(`quick-view:${this.sectionKey}`);
        } catch (error) {
          // nothing to clear when storage is unavailable
        }
      }

      rememberSectionId(id) {
        if (!id || this.renderSectionId === id) return;

        this.renderSectionId = id;

        try {
          sessionStorage.setItem(`quick-view:${this.sectionKey}`, id);
        } catch (error) {
          // private mode or blocked site data — the id still lives on the instance
        }
      }

      // Selecting a variant inside a popup must not rewrite the address of the page behind
      // it. updateURL() in product-variants.js returns early on
      // `dataset.updateUrl === 'false'`, and it is a method of ProductInfo — so the
      // attribute belongs on <product-info>, not on the variant picker.
      // (updateSellingPlanURL has no such guard: a subscription product can still move the
      // URL when a selling plan is picked.)
      prepareMarkup(root) {
        root
          .querySelectorAll('product-info')
          .forEach(el => el.setAttribute('data-update-url', 'false'));
      }

      // Renaming the swiper handles to something popup-specific would stop
      // `new Swiper('.swiper--' + handle)` in product-media-gallery.js from picking the
      // page's gallery when the popup is opened on a product page. It is not done,
      // because that file also has a hard `if (this.handle !== 'product-thumbs') return`
      // guarding the thumbs' centring logic — renaming switches it off and the thumbs
      // stop tracking the gallery everywhere, which is the worse trade. The document-wide
      // lookups therefore stay as they are: correct on collection, search and home pages,
      // unreliable only for a popup opened on a product page.

      localePrefix() {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const locale = window.Shopify && Shopify.locale;

        return locale && root.includes(`/${locale}/`) ? `/${locale}` : '';
      }

      /* ── Content ───────────────────────────────────────────────────────── */

      initContent(trigger) {
        // The vendor gallery links to its thumbs through
        // document.querySelector('[handle="product-thumbs"]').instance, and the gallery
        // sits before the thumbs in the DOM — so on first upgrade that instance does not
        // exist yet and the thumbs go dead. It re-initialises on window resize, so the
        // nudge has to come after its script has actually run, not on a fixed frame.
        this.loadInjectedScripts().then(() => this.refreshSliders());
        this.initGallery();
        this.syncOptionsFrom(trigger);
        this.watchVariantChanges();
        this.watchAddToCart();
      }

      // A <script src> assigned through innerHTML is inert. Any custom element it defines
      // upgrades the already-injected markup once the file has run, so re-requesting them
      // here is enough — no need to touch the markup itself.
      //
      // One at a time, in document order, because that is what `defer` guarantees on the
      // product page and the files depend on it: product-media-gallery.js reaches for
      // PhotoSwipeLightbox the moment it upgrades the injected gallery, so loading it
      // alongside photoswipe instead of after it throws a ReferenceError.
      loadInjectedScripts() {
        const sources = Array.from(this.panel.querySelectorAll('script[src]'), script => script.src);

        return sources.reduce(
          (chain, src) =>
            chain.then(() =>
              this.loadAsset('script', src).catch(error => console.error('[quick-view]', error))
            ),
          Promise.resolve()
        );
      }

      initGallery() {
        const gallery = this.panel.querySelector('[data-quick-view-gallery]');
        if (!gallery || typeof Swiper === 'undefined') return;

        this.counter = this.panel.querySelector('[data-quick-view-counter-current]');
        this.thumbs = Array.from(this.panel.querySelectorAll('.quick-view__thumb'));

        this.slider = new Swiper(gallery, {
          slidesPerView: 1,
          spaceBetween: 0,
          on: {
            slideChange: swiper => this.onSlideChange(swiper.activeIndex)
          }
        });

        this.thumbs.forEach(thumb => thumb.addEventListener('click', this.onThumbClick));
        this.onSlideChange(0);

        this.panel
          .querySelectorAll('.quick-view__slide-link')
          .forEach(link => link.addEventListener('click', this.onZoom));

        this.panel.querySelector('[data-quick-view-zoom]')?.addEventListener('click', this.onZoom);
      }

      onThumbClick = event => {
        const index = Number(event.currentTarget.dataset.index);
        this.slider?.slideTo(index);
      };

      onSlideChange(index) {
        if (this.counter) this.counter.textContent = String(index + 1);

        this.thumbs?.forEach(thumb => {
          thumb.classList.toggle('is--active', Number(thumb.dataset.index) === index);
        });
      }

      // The card the shopper clicked already has options selected; clicking the matching
      // input rather than setting `checked` is deliberate — it runs <product-card>'s own
      // handler, which is what updates the price, the form's variant id and the disabled
      // states. Matching is by value: two options sharing a value is rare enough that
      // reimplementing the theme's option maths to avoid it would cost more than it saves.
      syncOptionsFrom(trigger) {
        const card = trigger.closest('product-card');
        if (!card) return;

        const selected = card.querySelectorAll('input[type="radio"]:checked, select');
        if (!selected.length) return;

        const inputs = Array.from(this.panel.querySelectorAll('.variant-option-radio-input'));

        selected.forEach(source => {
          const match = inputs.find(input => input.value === source.value && !input.disabled);
          if (match && !match.checked) match.click();
        });
      }

      watchVariantChanges() {
        this.panel.addEventListener('change', this.onVariantOptionChange);
      }

      // Runs on the next frame so <product-card>'s click handler has already written the
      // new variant id into the form.
      onVariantOptionChange = event => {
        const input = event.target;
        if (!input.matches('input[type="radio"], input[type="checkbox"], select')) return;

        // Only our own markup carries this legend; main-product's picker paints its own.
        const legend = input.closest('.js-product-card-options')?.querySelector('[data-selected-variant]');
        if (legend) legend.textContent = input.value;

        // Next frame, so whichever picker owns the form has written the new variant id.
        requestAnimationFrame(() => {
          const variantId = Number(this.panel.querySelector('input[name="id"]')?.value);
          if (!variantId) return;

          // variantsObj exists on <product-card> only, so the availability and media work
          // is skipped for main-product, which drives both itself.
          const variant = this.panel.querySelector('product-card')?.variantsObj?.find(item => item.id === variantId);

          if (variant) {
            this.applyAvailability(variant);
            this.slideToVariantMedia(variant);
          }

          this.queueVariantRefresh();
        });
      };

      // <product-card> toggles the button's disabled attribute on its own but never its
      // label, and it knows nothing about the stock line.
      applyAvailability(variant) {
        if (!variant) return;

        const button = this.panel.querySelector('[data-quick-view-add]');
        const label = button?.querySelector('[data-quick-view-add-label]');
        const strings = window.variantStrings || {};

        if (button && label) {
          button.toggleAttribute('disabled', !variant.available);
          label.textContent = variant.available
            ? button.dataset.labelDefault
            : strings.soldOut || button.dataset.labelDefault;
        }

        const stock = this.panel.querySelector('[data-quick-view-stock]');
        const stockText = stock?.querySelector('[data-quick-view-stock-text]');

        if (stock && stockText) {
          stock.classList.toggle('quick-view__stock--out', !variant.available);
          stockText.textContent = variant.available ? stock.dataset.inStock : stock.dataset.soldOut;
        }
      }

      slideToVariantMedia(variant) {
        const mediaId = variant?.featured_media?.id;
        if (!mediaId) return;

        const slide = this.panel.querySelector(`.quick-view__slide[data-media-id="${mediaId}"]`);
        if (slide) this.slider?.slideTo(Number(slide.dataset.index));
      }

      // Same idea as data-variant-triggered on the product page: the accordion bodies are
      // Liquid (SKU, selected option values, metafields), so a fresh render is the only
      // source for them. Debounced because clicking through options fires this per click,
      // and deliberately not published over the 'variant-change' channel — that is shared,
      // and a popup opened on a product page would rewrite that page's accordions.
      // main-product also re-renders itself on a variant change and publishes the fresh
      // section over 'variant-change', which <product-accordion data-variant-triggered>
      // subscribes to — so this looked redundant, and handing it over was tried. It is not:
      // measured against the running theme, the vendor request returns the right content
      // (Metal Color: Yellow vs White for two selections) but its DOM update never reaches
      // the accordion inside the popup, and the panel then never changes at all. So the
      // refresh below stays, and the ordering guard in refreshVariantContent is what keeps
      // the two writers from contradicting each other.
      queueVariantRefresh() {
        clearTimeout(this.variantRefreshTimer);

        // Read at fire time, not now: main-product writes the new variant id into the form
        // only after its own request comes back, so anything captured here would still be
        // the previous variant.
        this.variantRefreshTimer = setTimeout(() => this.refreshVariantContent(this.variantParams()), 250);
      }

      // The same parameters the vendor picker builds, taken from the DOM rather than from
      // the form: `fieldset input:checked` is live the moment the shopper clicks, while
      // input[name="id"] lags a request behind. Falls back to the variant id for our own
      // section, whose options carry no option-value ids.
      variantParams() {
        const optionValues = Array.from(
          this.panel.querySelectorAll(
            'product-variant-selects select option[selected], product-variant-selects fieldset input:checked'
          )
        )
          .map(element => element.dataset.optionValueId)
          .filter(Boolean);

        if (optionValues.length) return `&option_values=${optionValues.join(',')}`;

        const variantId = this.panel.querySelector('input[name="id"]')?.value;

        return variantId ? `&variant=${variantId}` : '';
      }

      async refreshVariantContent(params) {
        const panels = this.panel.querySelectorAll(
          'product-accordion[data-variant-triggered] .product-accordion__content[id]'
        );
        if (!panels.length || !this.productUrl) return;

        if (!params) return;

        // Responses can land out of order, so a slow fetch for an earlier selection must
        // not overwrite a newer one that already arrived.
        this.variantRequestId = params;

        try {
          const doc = await this.fetchVariantDocument(params);
          if (this.variantRequestId !== params) return;

          panels.forEach(node => {
            const fresh = doc.getElementById(node.id);
            const accordion = node.closest('product-accordion');

            // Absent means this variant has nothing to show, not that nothing changed —
            // without hiding it the previous variant's text would stay on screen.
            if (!fresh) {
              if (accordion) accordion.hidden = true;
              return;
            }

            if (accordion) accordion.hidden = false;
            node.innerHTML = fresh.innerHTML;
          });
        } catch (error) {
          console.error('[quick-view]', error);
        }
      }

      async fetchVariantDocument(params) {
        const url = this.viewUrl(this.productUrl, params);

        if (this.variantCache.has(url)) {
          return new DOMParser().parseFromString(this.variantCache.get(url), 'text/html');
        }

        const response = await fetch(url);
        if (!response.ok) throw new Error(`${response.status} for ${url}`);

        const text = await response.text();
        this.variantCache.set(url, text);

        return new DOMParser().parseFromString(text, 'text/html');
      }

      watchAddToCart() {
        if (this.dataset.closeAfterAdd !== 'true') return;

        // Our own markup posts through <product-card>, which publishes nothing — hence the
        // observer below.
        this.panel.querySelector('.quick-view__form')?.addEventListener('submit', this.onAddToCart);

        // main-product's buy buttons go through product-form, which publishes cart-update
        // only once the request came back without errors. The event name is a literal
        // rather than PUB_SUB_EVENTS.cartUpdate so this does not depend on global.js
        // having run first.
        if (typeof subscribe === 'function' && !this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber = subscribe('cart-update', event => {
            if (event?.source !== 'product-form') return;
            this.close();
          });
        }
      }

      // <product-card> adds the cart over fetch and re-enables the button in its own
      // finally block, so that attribute is the signal the request finished. The error
      // wrapper says whether it succeeded — a failed add keeps the popup open with the
      // message visible.
      onAddToCart = event => {
        const button = event.currentTarget.querySelector('button[type="submit"]');
        if (!button) return;

        this.addToCartObserver?.disconnect();
        this.addToCartObserver = new MutationObserver(() => {
          if (button.hasAttribute('disabled')) return;

          this.addToCartObserver.disconnect();

          const error = this.panel.querySelector('.product-form__error-message-wrapper');
          if (error && !error.hasAttribute('hidden')) return;

          this.close();
        });

        this.addToCartObserver.observe(button, { attributes: true, attributeFilter: ['disabled'] });
      };

      teardownContent() {
        clearTimeout(this.variantRefreshTimer);
        this.cartUpdateUnsubscriber?.();
        this.cartUpdateUnsubscriber = null;
        this.panel.removeEventListener('change', this.onVariantOptionChange);
        this.addToCartObserver?.disconnect();
        this.addToCartObserver = null;

        this.lightbox?.destroy();
        this.lightbox = null;

        this.slider?.destroy(true, true);
        this.slider = null;

        this.thumbs = null;
        this.counter = null;
      }

      /* ── Zoom ──────────────────────────────────────────────────────────── */

      // PhotoSwipe is ~67 KB, so it is pulled on the first zoom rather than on every
      // page. Once init() runs PhotoSwipe binds the slide links itself; the extra
      // loadAndOpen below is a no-op while the lightbox is already open.
      onZoom = async event => {
        event.preventDefault();

        const slide = event.target.closest('.quick-view__slide');
        const index = slide ? Number(slide.dataset.index) : this.slider?.activeIndex || 0;

        try {
          const lightbox = await this.lightboxInstance();
          lightbox.loadAndOpen(index);
        } catch (error) {
          console.error('[quick-view] zoom unavailable', error);
        }
      };

      async lightboxInstance() {
        if (this.lightbox) return this.lightbox;

        await this.loadPhotoSwipe();

        this.lightbox = new window.PhotoSwipeLightbox({
          gallery: this.panel.querySelector('.photoswipe-wrapper'),
          children: 'a.product__gallery-toggle',
          mainClass: 'pswp--quick-view',
          showHideAnimationType: 'zoom',
          pswpModule: window.PhotoSwipe
        });
        this.lightbox.init();

        return this.lightbox;
      }

      loadPhotoSwipe() {
        if (this.photoSwipeReady) return this.photoSwipeReady;

        // The product template already ships PhotoSwipe, so on that page there is
        // nothing to fetch
        if (window.PhotoSwipe && window.PhotoSwipeLightbox) {
          this.photoSwipeReady = Promise.resolve();
          return this.photoSwipeReady;
        }

        const assets = this.dataset;

        // The stylesheet is independent, the two scripts are not: the lightbox is loaded
        // after the core for the same reason the injected scripts are chained.
        this.photoSwipeReady = Promise.all([
          this.loadAsset('link', assets.photoswipeCss),
          this.loadAsset('script', assets.photoswipeJs).then(() =>
            this.loadAsset('script', assets.photoswipeLightboxJs)
          )
        ]);

        return this.photoSwipeReady;
      }

      loadAsset(kind, url) {
        return new Promise((resolve, reject) => {
          if (!url) {
            reject(new Error(`missing ${kind} url`));
            return;
          }

          const existing = document.querySelector(`[data-quick-view-asset="${url}"]`);
          if (existing) {
            if (existing.dataset.loaded === 'true') resolve();
            else existing.addEventListener('load', () => resolve(), { once: true });
            return;
          }

          const node = document.createElement(kind === 'link' ? 'link' : 'script');
          node.dataset.quickViewAsset = url;

          if (kind === 'link') {
            node.rel = 'stylesheet';
            node.href = url;
          } else {
            node.src = url;
          }

          node.addEventListener(
            'load',
            () => {
              node.dataset.loaded = 'true';
              resolve();
            },
            { once: true }
          );
          node.addEventListener('error', () => reject(new Error(`failed to load ${url}`)), { once: true });

          document.head.appendChild(node);
        });
      }

      /* ── Open / close ──────────────────────────────────────────────────── */

      open() {
        if (this.isOpen) return;

        this.isOpen = true;
        clearTimeout(this.unmountTimer);

        // A quick view opened from the cart drawer's recommendations would land underneath
        // the drawer — close it first. Its close() sets body overflow inline; the
        // overflow-hidden class added below is !important, so the page stays locked.
        document.querySelector('cart-drawer.is-visible')?.close();

        this.classList.add('is--rendered');

        // Two frames: one for the browser to lay the element out now that it is no longer
        // display: none, one for the opacity transition to have a starting point.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (this.isOpen) this.classList.add('is--open');
          });
        });

        document.body.classList.add('overflow-hidden');
        this.dialog?.focus();

        requestAnimationFrame(() => this.refreshSliders());
      }

      // The pinned buy-buttons bar on mobile is taken out of flow, so the scroller needs
      // matching bottom padding or the last block hides behind it. Measured rather than
      // guessed: the bar is one row or two depending on the quantity picker and the dynamic
      // checkout button.
      updateStickyBar() {
        const bar = this.panel.querySelector('.product-form__buttons');
        if (!bar || !this.dialog) return;

        const pinned = window.matchMedia('(max-width: 749px)').matches;

        this.dialog.style.setProperty(
          '--quick-view-sticky-height',
          pinned ? `${bar.offsetHeight}px` : '0px'
        );
      }

      onViewportChange = () => this.updateStickyBar();

      refreshSliders() {
        this.updateStickyBar();
        this.slider?.update();
        window.dispatchEvent(new Event('resize'));
        this.relinkProductGallery();
      }

      // The vendor gallery links to its thumbs by reading `.instance` off the thumbs
      // element, and it sits before them in the DOM — so on the upgrade that matters the
      // instance is not there yet and the thumbs end up dead. Its init() cannot repair
      // that on its own: it returns early on a `swiperInitialized` flag, which is why a
      // resize changes nothing and why the second open used to work — back then the
      // element had no dimensions yet, so init() bailed before setting the flag and a
      // later run got it right. Rebuilding the instance is the only way left.
      async relinkProductGallery() {
        const gallery = this.panel.querySelector('swiper-product-gallery');
        const thumbs = this.panel.querySelector('swiper-product-thumbs');
        if (!gallery || !thumbs) return;

        try {
          await Promise.all([
            customElements.whenDefined('swiper-product-gallery'),
            customElements.whenDefined('swiper-product-thumbs')
          ]);
        } catch (error) {
          return;
        }

        // The thumbs have to own an instance before the gallery looks for one, and their
        // init() also bails out while the element still measures zero — so it gets a few
        // frames rather than a single try.
        for (let attempt = 0; attempt < 4 && !thumbs.instance; attempt += 1) {
          thumbs.init?.();
          if (thumbs.instance) break;

          await new Promise(resolve => requestAnimationFrame(resolve));
        }

        if (!thumbs.instance) {
          console.warn('[quick-view] thumbs slider never initialised', {
            width: thumbs.offsetWidth,
            height: thumbs.offsetHeight
          });
          return;
        }

        if (gallery.instance?.thumbs?.swiper) return;

        gallery.instance?.destroy?.(true, true);
        gallery.swiperInitialized = false;
        gallery.init?.();
      }

      close() {
        if (!this.isOpen) return;

        this.isOpen = false;
        this.classList.remove('is--open');

        // Unmount once the fade has finished. The timer is the fallback for the cases
        // where transitionend never fires — reduced motion, or a tab in the background.
        clearTimeout(this.unmountTimer);
        this.unmountTimer = setTimeout(() => this.unmount(), 600);
        this.dialog?.addEventListener('transitionend', this.onCloseTransitionEnd, { once: true });

        // The cart drawer may have opened on top of the popup, and it owns the lock too
        if (!document.querySelector('cart-drawer.is--open, quick-cart-drawer.is--open')) {
          document.body.classList.remove('overflow-hidden');
        }
      }

      onCloseTransitionEnd = event => {
        if (event.propertyName === 'opacity') this.unmount();
      };

      unmount() {
        clearTimeout(this.unmountTimer);
        if (!this.isOpen) this.classList.remove('is--rendered');
      }

      trapFocus(event) {
        const focusable = Array.from(
          this.dialog.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')
        ).filter(node => !node.disabled && node.offsetParent !== null);

        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('quick-view-popup', QuickViewPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-complementary"] && !Shopify.designMode) return;
  try {
    
  class ComplementarySlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.section-complementary__track');
      this.slider = this.querySelector('.section-complementary__slider');
      this.swiper = null;
      this.mediaObserver = null;

      if (!this.track) return;

      /* Slides printed straight from the metafield are already in the track — there is
         nothing to fetch, only a slider to start. */
      if (this.track.querySelector('.swiper-slide')) {
        this.start();
        return;
      }

      if (!this.dataset.url) return;
      this.load();
    }

    async start() {
      await this.whenSwiperReady();
      if (this.isConnected) this.initSwiper();
    }

    disconnectedCallback() {
      this.mediaObserver?.disconnect();
      this.mediaObserver = null;
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    /* Complementary products are not part of the product page's own render — they only
       exist behind routes.product_recommendations_url, so the slides have to be fetched.
       An empty answer is the normal case (no complementary list for this product): leave
       the track empty and the section stays hidden by its own :has() rule. */
    async load() {
      let markup = '';

      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        markup = doc.querySelector('[data-complementary-slides]')?.innerHTML.trim() || '';
      } catch (error) {
        return;
      }

      if (!markup || !this.isConnected) return;

      /* Each card is a <product-card>; the element upgrades itself on insertion and
         global.js runs its init() from the constructor, so nothing to wire up here.
         quick-cart-drawer.js binds its triggers through a MutationObserver on body. */
      this.track.innerHTML = markup;

      this.start();
    }

    /* Swiper is a deferred global script; it normally executes before this bundle,
       but resolve defensively rather than assume the order. */
    whenSwiperReady() {
      if (typeof window.Swiper !== 'undefined') return Promise.resolve();

      return new Promise((resolve) => {
        const start = performance.now();
        const poll = () => {
          if (typeof window.Swiper !== 'undefined' || performance.now() - start > 5000) {
            resolve();
            return;
          }
          requestAnimationFrame(poll);
        };
        poll();
      });
    }

    initSwiper() {
      if (!this.slider || this.swiper || typeof window.Swiper === 'undefined') return;

      const { slidesDesktop, slidesTablet, slidesMobile, spaceDesktop, spaceMobile } = this.dataset;

      /* `Number(x) || fallback` would swallow a deliberate 0 gap. */
      const num = (value, fallback) => {
        const parsed = Number(value);
        return value === '' || value == null || Number.isNaN(parsed) ? fallback : parsed;
      };

      const gapDesktop = num(spaceDesktop, 32);

      this.swiper = new window.Swiper(this.slider, {
        slidesPerView: num(slidesMobile, 1.5),
        spaceBetween: num(spaceMobile, 12),
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector('.section-complementary__arrow--prev'),
          nextEl: this.querySelector('.section-complementary__arrow--next'),
          disabledClass: 'swiper-button-disabled',
        },
        pagination: {
          el: this.querySelector('.section-complementary__progress'),
          type: 'progressbar',
        },
        breakpoints: {
          750: {
            slidesPerView: num(slidesTablet, 2),
            spaceBetween: gapDesktop,
          },
          990: {
            slidesPerView: num(slidesDesktop, 4),
            spaceBetween: gapDesktop,
          },
        },
      });

      this.watchMedia();
    }

    /* The arrows centre on the product image rather than on the slider, so its box has to
       be measured: with the card aspect ratio set to "auto" the height is the image's own,
       and even a fixed ratio only resolves once Swiper has sized the slide. A
       ResizeObserver covers all of it — first layout, image load, viewport resize — and
       fires immediately on observe, so no separate initial measurement is needed. */
    watchMedia() {
      const media = this.track?.querySelector('.product-card__media');
      if (!media) return;

      if (typeof ResizeObserver === 'undefined') {
        this.measureMedia(media);
        return;
      }

      this.mediaObserver = new ResizeObserver(() => this.measureMedia(media));
      this.mediaObserver.observe(media);
    }

    /* Offset as well as height: the media is not necessarily flush with the top of the
       slider (a badge row or card padding above it would shift it down). */
    measureMedia(media) {
      if (!this.slider) return;

      const height = media.offsetHeight;
      /* Nothing laid out yet — the observer will call back once there is. */
      if (!height) return;

      const offset = media.getBoundingClientRect().top - this.slider.getBoundingClientRect().top;

      this.slider.style.setProperty('--complementary-arrow-center', `${offset + height / 2}px`);
    }
  }

  if (!customElements.get('complementary-slider')) {
    customElements.define('complementary-slider', ComplementarySlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-featured-products"] && !Shopify.designMode) return;
  try {
    
  const FP_DESKTOP_QUERY = '(min-width: 750px)';

  class FeaturedProductsTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.featured-products__tab'));
      this.panels = Array.from(this.querySelectorAll('.featured-products__panel'));
      this.viewAll = this.querySelector('.featured-products__view-all');
      this.swipers = new Map();
      this.desktopQuery = window.matchMedia(FP_DESKTOP_QUERY);

      this.onTabClick = this.onTabClick.bind(this);
      this.onTabKeydown = this.onTabKeydown.bind(this);
      this.onBreakpointChange = this.onBreakpointChange.bind(this);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onTabClick);
        tab.addEventListener('keydown', this.onTabKeydown);
      });
      this.desktopQuery.addEventListener('change', this.onBreakpointChange);

      this.whenSwiperReady().then(() => {
        if (!this.isConnected) return;
        this.syncSwipers();
      });
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.onTabClick);
        tab.removeEventListener('keydown', this.onTabKeydown);
      });
      this.desktopQuery.removeEventListener('change', this.onBreakpointChange);
      this.destroySwipers();
    }

    /* Swiper is a deferred global script; it normally executes before this
       bundle, but resolve defensively rather than assume the order. */
    whenSwiperReady() {
      if (typeof window.Swiper !== 'undefined') return Promise.resolve();

      return new Promise((resolve) => {
        const start = performance.now();
        const poll = () => {
          if (typeof window.Swiper !== 'undefined' || performance.now() - start > 5000) {
            resolve();
            return;
          }
          requestAnimationFrame(poll);
        };
        poll();
      });
    }

    get activeIndex() {
      const index = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      return index === -1 ? 0 : index;
    }

    onTabClick(event) {
      this.selectTab(this.tabs.indexOf(event.currentTarget));
    }

    onTabKeydown(event) {
      const offsets = { ArrowRight: 1, ArrowLeft: -1 };
      const offset = offsets[event.key];
      if (!offset) return;

      event.preventDefault();
      const next = (this.activeIndex + offset + this.tabs.length) % this.tabs.length;
      this.selectTab(next);
      this.tabs[next].focus();
    }

    selectTab(index) {
      if (index < 0 || index === this.activeIndex) return;

      this.tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel, i) => {
        panel.toggleAttribute('hidden', i !== index);
      });

      const url = this.tabs[index].dataset.collectionUrl;
      if (this.viewAll && url) this.viewAll.setAttribute('href', url);

      /* The panel had display:none, so Swiper measured nothing — build it now
         if this is its first reveal, otherwise re-measure. */
      this.syncSwipers();
      this.swipers.get(this.panels[index])?.update();
    }

    onBreakpointChange() {
      this.syncSwipers();
    }

    syncSwipers() {
      if (!this.desktopQuery.matches) {
        this.destroySwipers();
        return;
      }
      const panel = this.panels[this.activeIndex];
      if (panel && !this.swipers.has(panel)) this.initSwiper(panel);
    }

    initSwiper(panel) {
      const slider = panel.querySelector('.featured-products__slider');
      if (!slider || typeof window.Swiper === 'undefined') return;

      const { slidesDesktop, slidesTablet, spaceDesktop, spaceMobile, loop } = this.dataset;
      const slideCount = Number(panel.dataset.slideCount) || 0;

      const swiper = new window.Swiper(slider, {
        slidesPerView: Number(slidesTablet) || 3,
        spaceBetween: Number(spaceMobile) || 16,
        watchOverflow: true,
        /* Looping needs more slides than are on screen or Swiper duplicates
           them into a jittery track. */
        loop: loop === 'true' && slideCount > (Number(slidesDesktop) || 4),
        pagination: {
          el: panel.querySelector('.featured-products__progress'),
          type: 'progressbar',
        },
        breakpoints: {
          990: {
            slidesPerView: Number(slidesDesktop) || 4,
            spaceBetween: Number(spaceDesktop) || 24,
          },
        },
      });

      this.swipers.set(panel, swiper);
    }

    destroySwipers() {
      this.swipers.forEach((swiper) => swiper.destroy(true, true));
      this.swipers.clear();
    }
  }

  if (!customElements.get('featured-products-tabs')) {
    customElements.define('featured-products-tabs', FeaturedProductsTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-image-cards"] && !Shopify.designMode) return;
  try {
    
  class ImageCardsSlider extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.image-cards__slider');
      this.swiper = null;

      this.whenSwiperReady().then(() => {
        if (this.isConnected) this.init();
      });
    }

    disconnectedCallback() {
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    /* Swiper is a deferred global script; it normally executes before this
       bundle, but resolve defensively rather than assume the order. */
    whenSwiperReady() {
      if (typeof window.Swiper !== 'undefined') return Promise.resolve();

      return new Promise((resolve) => {
        const start = performance.now();
        const poll = () => {
          if (typeof window.Swiper !== 'undefined' || performance.now() - start > 5000) {
            resolve();
            return;
          }
          requestAnimationFrame(poll);
        };
        poll();
      });
    }

    init() {
      if (!this.slider || this.swiper || typeof window.Swiper === 'undefined') return;

      const { slidesDesktop, slidesTablet, slidesMobile, spaceDesktop, spaceMobile, loop } =
        this.dataset;

      /* `Number(x) || fallback` would swallow a deliberate 0 gap. */
      const num = (value, fallback) => {
        const parsed = Number(value);
        return value === '' || value == null || Number.isNaN(parsed) ? fallback : parsed;
      };

      const perViewDesktop = num(slidesDesktop, 3);
      const gapDesktop = num(spaceDesktop, 24);
      const slideCount = this.querySelectorAll('.image-cards__slide').length;

      this.swiper = new window.Swiper(this.slider, {
        slidesPerView: num(slidesMobile, 1.5),
        spaceBetween: num(spaceMobile, 12),
        /* Disables dragging when every card already fits. */
        watchOverflow: true,
        /* Looping needs more slides than are on screen, or Swiper duplicates
           them into a jittery track. */
        loop: loop === 'true' && slideCount > perViewDesktop,
        breakpoints: {
          750: {
            slidesPerView: num(slidesTablet, 2),
            spaceBetween: gapDesktop,
          },
          990: {
            slidesPerView: perViewDesktop,
            spaceBetween: gapDesktop,
          },
        },
      });
    }
  }

  if (!customElements.get('image-cards-slider')) {
    customElements.define('image-cards-slider', ImageCardsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-related"] && !Shopify.designMode) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.section-related__track');
      this.slider = this.querySelector('.section-related__slider');
      this.swiper = null;
      this.mediaObserver = null;

      if (!this.track || !this.dataset.url) return;
      this.load();
    }

    disconnectedCallback() {
      this.mediaObserver?.disconnect();
      this.mediaObserver = null;
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    /* Related products are not part of the product page's own render — they only exist
       behind routes.product_recommendations_url, so the slides have to be fetched. An
       empty answer is the normal case (Shopify has no related list for this product):
       leave the track empty and the section stays hidden by its own :has() rule. */
    async load() {
      let markup = '';

      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        markup = doc.querySelector('[data-related-slides]')?.innerHTML.trim() || '';
      } catch (error) {
        return;
      }

      if (!markup || !this.isConnected) return;

      /* Each card is a <product-card>; the element upgrades itself on insertion and
         global.js runs its init() from the constructor, so nothing to wire up here.
         quick-cart-drawer.js binds its triggers through a MutationObserver on body. */
      this.track.innerHTML = markup;

      await this.whenSwiperReady();
      if (this.isConnected) this.initSwiper();
    }

    /* Swiper is a deferred global script; it normally executes before this bundle,
       but resolve defensively rather than assume the order. */
    whenSwiperReady() {
      if (typeof window.Swiper !== 'undefined') return Promise.resolve();

      return new Promise((resolve) => {
        const start = performance.now();
        const poll = () => {
          if (typeof window.Swiper !== 'undefined' || performance.now() - start > 5000) {
            resolve();
            return;
          }
          requestAnimationFrame(poll);
        };
        poll();
      });
    }

    initSwiper() {
      if (!this.slider || this.swiper || typeof window.Swiper === 'undefined') return;

      const { slidesDesktop, slidesTablet, slidesMobile, spaceDesktop, spaceMobile } = this.dataset;

      /* `Number(x) || fallback` would swallow a deliberate 0 gap. */
      const num = (value, fallback) => {
        const parsed = Number(value);
        return value === '' || value == null || Number.isNaN(parsed) ? fallback : parsed;
      };

      const gapDesktop = num(spaceDesktop, 32);

      this.swiper = new window.Swiper(this.slider, {
        slidesPerView: num(slidesMobile, 1.5),
        spaceBetween: num(spaceMobile, 12),
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector('.section-related__arrow--prev'),
          nextEl: this.querySelector('.section-related__arrow--next'),
          disabledClass: 'swiper-button-disabled',
        },
        pagination: {
          el: this.querySelector('.section-related__progress'),
          type: 'progressbar',
        },
        breakpoints: {
          750: {
            slidesPerView: num(slidesTablet, 2),
            spaceBetween: gapDesktop,
          },
          990: {
            slidesPerView: num(slidesDesktop, 4),
            spaceBetween: gapDesktop,
          },
        },
      });

      this.watchMedia();
    }

    /* The arrows centre on the product image rather than on the slider, so its box has to
       be measured: with the card aspect ratio set to "auto" the height is the image's own,
       and even a fixed ratio only resolves once Swiper has sized the slide. A
       ResizeObserver covers all of it — first layout, image load, viewport resize — and
       fires immediately on observe, so no separate initial measurement is needed. */
    watchMedia() {
      const media = this.track?.querySelector('.product-card__media');
      if (!media) return;

      if (typeof ResizeObserver === 'undefined') {
        this.measureMedia(media);
        return;
      }

      this.mediaObserver = new ResizeObserver(() => this.measureMedia(media));
      this.mediaObserver.observe(media);
    }

    /* Offset as well as height: the media is not necessarily flush with the top of the
       slider (a badge row or card padding above it would shift it down). */
    measureMedia(media) {
      if (!this.slider) return;

      const height = media.offsetHeight;
      /* Nothing laid out yet — the observer will call back once there is. */
      if (!height) return;

      const offset = media.getBoundingClientRect().top - this.slider.getBoundingClientRect().top;

      this.slider.style.setProperty('--related-arrow-center', `${offset + height / 2}px`);
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.sticky-atc__panel');
      this.toggleButton = this.querySelector('[data-sticky-toggle]');
      this.closeButton = this.querySelector('[data-sticky-close]');
      this.submitButton = this.querySelector('[data-sticky-submit]');
      this.submitText = this.querySelector('[data-sticky-submit-text]');
      this.priceTarget = this.querySelector('[data-sticky-price]');
      this.mediaImage = this.querySelector('.sticky-atc__media img');

      this.toggleButton?.addEventListener('click', this.onToggle);
      this.closeButton?.addEventListener('click', this.onClose);
      this.submitButton?.addEventListener('click', this.onSubmit);
      this.addEventListener('change', this.onOptionChange);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeyDown);
      document.addEventListener('product-info:loaded', this.onProductInfoLoaded);

      /* pubsub.js and global.js are deferred ahead of this bundle in theme.liquid, but
         a missing subscriber should degrade to a static bar, not throw. */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribers = [
          subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange),
          subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartSettled),
          subscribe(PUB_SUB_EVENTS.cartError, this.onCartSettled),
        ];
      }

      /* The panel only exists below 990px — above it the toggle that opens it is
         display:none and every control is already inline. Kept as a live query so a device
         rotating past the breakpoint with the panel open cannot leave the body locked. */
      this.collapsedQuery = window.matchMedia('(max-width: 989px)');
      this.collapsedQuery.addEventListener('change', this.onBreakpointChange);

      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
      }

      this.connectToMainProduct();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.footerObserver?.disconnect();
      this.footerObserver = null;
      clearTimeout(this.loadingTimeout);

      this.toggleButton?.removeEventListener('click', this.onToggle);
      this.closeButton?.removeEventListener('click', this.onClose);
      this.submitButton?.removeEventListener('click', this.onSubmit);
      this.removeEventListener('change', this.onOptionChange);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('product-info:loaded', this.onProductInfoLoaded);
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);

      this.collapsedQuery?.removeEventListener('change', this.onBreakpointChange);
      this.collapsedQuery = null;

      /* The theme editor pulls the section out of the DOM; a lock taken while the panel
         was open would otherwise outlive it and freeze the page. */
      this.unlockScroll();

      this.unsubscribers?.forEach((unsubscribe) => unsubscribe());
      this.unsubscribers = null;
    }

    /* A combined-listing swap replaces `product-info` wholesale, so every reference into
       it is resolved again whenever a product-info announces itself. */
    connectToMainProduct = () => {
      this.mainProduct = document.querySelector('product-info[data-main-product]');
      if (!this.mainProduct) return;

      this.observer?.disconnect();
      this.observerTarget = this.mainProduct.querySelector('.product-form__buttons');

      if (this.observerTarget) {
        this.observer = new IntersectionObserver(this.onIntersect);
        this.observer.observe(this.observerTarget);
      }

      /* The bar would otherwise sit on top of the footer; the first section of the footer
         group reaching the viewport is the cue to get out of the way. */
      if (!this.footerObserver) {
        const footer = document.querySelector('.shopify-section-group-footer-group');
        if (footer) {
          this.footerObserver = new IntersectionObserver(this.onFooterIntersect);
          this.footerObserver.observe(footer);
        }
      }

      this.syncOptionState();
      this.syncSubmitState();
      this.syncDropdownSwatches();
    };

    onProductInfoLoaded = () => {
      this.connectToMainProduct();
    };

    /* Visible only once the real buy buttons have left the top of the viewport — while
       they are still below the fold the bar would just duplicate them. */
    onIntersect = (entries) => {
      entries.forEach((entry) => {
        this.scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      });
      this.updateVisibility();
    };

    onFooterIntersect = (entries) => {
      entries.forEach((entry) => {
        this.footerReached = entry.isIntersecting;
      });
      this.updateVisibility();
    };

    updateVisibility() {
      const visible = this.scrolledPast === true && this.footerReached !== true;
      this.classList.toggle('is-visible', visible);
      if (!visible) this.close();
    }

    onToggle = () => {
      this.classList.contains('is-open') ? this.close() : this.open();
    };

    onClose = () => {
      this.close();
      this.toggleButton?.focus({ preventScroll: true });
    };

    open() {
      this.classList.add('is-open');
      this.toggleButton?.setAttribute('aria-expanded', 'true');
      this.lockScroll();
    }

    /* Every exit route runs through here — the close button, a click outside, Escape, the
       bar hiding itself again, add-to-cart settling — so the lock is released once, in one
       place. The early return keeps lock and unlock symmetrical. */
    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.toggleButton?.setAttribute('aria-expanded', 'false');
      this.unlockScroll();
    }

    /* Crossing to the desktop layout with the panel still open would strand the lock:
       above 990px the close button is gone, so there is nothing left to dismiss it with. */
    onBreakpointChange = (event) => {
      if (!event.matches) this.close();
    };

    /* Expanded, the panel is a sheet over the page — the page behind it must not scroll
       away under the finger. bodyScrollLock is the theme's own helper (loaded globally in
       theme.liquid, used by the cart and wishlist drawers): it handles the iOS cases a
       bare `overflow: hidden` on body does not, and leaves the panel itself scrollable. */
    lockScroll() {
      if (!this.panel || !window.bodyScrollLock) return;
      if (this.collapsedQuery && !this.collapsedQuery.matches) return;

      window.bodyScrollLock.disableBodyScroll(this.panel);
    }

    unlockScroll() {
      if (!this.panel || !window.bodyScrollLock) return;

      window.bodyScrollLock.enableBodyScroll(this.panel);
    }

    onDocumentClick = (event) => {
      if (!this.contains(event.target)) this.close();
    };

    onKeyDown = (event) => {
      if (event.key === 'Escape') this.close();
    };

    onSectionSelect = (event) => {
      if (event.target.contains(this)) this.classList.add('is-visible');
    };

    onSectionDeselect = (event) => {
      if (!event.target.contains(this)) return;
      this.classList.remove('is-visible');
      this.close();
    };

    get mainPicker() {
      return this.mainProduct?.querySelector('product-variant-selects') || null;
    }

    get mainSubmitButton() {
      return this.mainProduct?.querySelector('.product-form__submit') || null;
    }

    onSubmit = () => {
      const mainSubmit = this.mainSubmitButton;
      if (!mainSubmit || mainSubmit.hasAttribute('disabled')) return;
      if (this.submitButton.hasAttribute('disabled')) return;

      this.submitButton.classList.add('is-loading');
      clearTimeout(this.loadingTimeout);
      /* cartUpdate/cartError clear this; the timeout covers a request that never settles. */
      this.loadingTimeout = setTimeout(() => {
        this.submitButton.classList.remove('is-loading');
      }, 10000);

      mainSubmit.click();
    };

    onCartSettled = () => {
      clearTimeout(this.loadingTimeout);
      this.submitButton?.classList.remove('is-loading');
      this.close();
    };

    /* The bar never selects a variant itself: it forwards the choice to the real picker
       and lets `product-info` update the page, then reads the result back. */
    onOptionChange = (event) => {
      const target = event.target;
      const optionValueId =
        target.tagName === 'SELECT'
          ? target.selectedOptions[0]?.dataset.optionValueId
          : target.dataset?.optionValueId;

      if (!optionValueId) return;

      /* `product-info` focuses the option it thinks was clicked once its fetch resolves —
         an element up in the product form, which scrolls the page away from the bar. Both
         are undone on the frame after, before the browser paints, so nothing is visible. */
      this.pendingScrollY = window.scrollY;
      this.pendingFocusId = target.id || null;

      this.selectInMainPicker(optionValueId);
      /* `dropdown-input` rebuilds its summary from a static template right after this
         handler, wiping the swatch — so restore it on the next frame. */
      requestAnimationFrame(this.syncDropdownSwatches);
    };

    selectInMainPicker(optionValueId) {
      const picker = this.mainPicker;
      if (!picker) return;

      const source = picker.querySelector(
        `[data-option-value-id="${CSS.escape(optionValueId)}"]`
      );
      if (!source) return;

      if (source.tagName === 'OPTION') {
        const select = source.closest('select');
        if (!select || select.value === source.value) return;
        select.value = source.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      if (source.checked) return;
      source.checked = true;
      source.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onVariantChange = ({ data }) => {
      this.syncOptionState();
      this.syncPrice(data?.html, data?.sectionId);
      this.syncMedia(data?.variant);
      this.syncSubmitState(data?.html, data?.sectionId);
      requestAnimationFrame(this.afterVariantChange);
    };

    afterVariantChange = () => {
      this.syncDropdownSwatches();
      this.restoreScroll();
      this.restoreFocus();
    };

    restoreScroll() {
      const top = this.pendingScrollY;
      this.pendingScrollY = null;
      if (top == null || Math.abs(window.scrollY - top) < 2) return;
      window.scrollTo({ top, left: window.scrollX, behavior: 'instant' });
    }

    restoreFocus() {
      const id = this.pendingFocusId;
      this.pendingFocusId = null;
      if (!id) return;

      const control = this.querySelector(`#${CSS.escape(id)}`);
      if (!control) return;

      /* The dropdown throws away its summary on every pick, so take the current one. */
      const target =
        control.tagName === 'SELECT'
          ? control.closest('.sticky-atc__option')?.querySelector('summary')
          : control;

      target?.focus({ preventScroll: true });
    }

    syncOptionState() {
      const picker = this.mainPicker;
      if (!picker) return;

      const readSource = (id) =>
        picker.querySelector(`[data-option-value-id="${CSS.escape(id)}"]`);

      this.querySelectorAll('input[data-option-value-id]').forEach((input) => {
        const source = readSource(input.dataset.optionValueId);
        if (!source) return;
        input.checked = source.tagName === 'OPTION' ? source.selected : source.checked;
        input.disabled = source.disabled;
      });

      this.querySelectorAll('.sticky-atc__option select').forEach((select) => {
        const selected = Array.from(select.options).find((option) => {
          const source = readSource(option.dataset.optionValueId);
          return source ? (source.tagName === 'OPTION' ? source.selected : source.checked) : false;
        });
        if (!selected || selected.selected) return;

        Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
        selected.setAttribute('selected', 'selected');
        select.value = selected.value;
        select.closest('dropdown-input')?.update?.();
      });

      this.querySelectorAll('.sticky-atc__option-group').forEach((group) => {
        const checked = group.querySelector('input:checked');
        const label = group.querySelector('[data-selected-value]');
        if (checked && label) label.textContent = checked.value;
      });
    }

    syncDropdownSwatches = () => {
      this.querySelectorAll('.sticky-atc__option').forEach((wrapper) => {
        const select = wrapper.querySelector('select');
        if (!select) return;

        const summarySwatch = wrapper.querySelector('.dropdown__button .product-option__swatch');
        const selected = select.selectedOptions[0];
        if (summarySwatch && selected) {
          this.paintSwatch(summarySwatch, selected.dataset.optionSwatchValue);
        }

        /* `dropdown-input` fills each list item with textContent, which wipes anything the
           template put there — so the thumbnail is added after it has built the list, and
           again after every rebuild. Item order matches the select's option order. */
        wrapper.querySelectorAll('.dropdown__item-button').forEach((button, index) => {
          const value = select.options[index]?.dataset.optionSwatchValue;
          if (!value) return;

          let swatch = button.querySelector('.sticky-atc__item-swatch');
          if (!swatch) {
            swatch = document.createElement('span');
            swatch.className = 'sticky-atc__item-swatch';
            button.prepend(swatch);
          }
          this.paintSwatch(swatch, value);
        });
      });
    };

    paintSwatch(element, value) {
      element.style.setProperty('--swatch--background', value || 'unset');
      element.classList.toggle('product-option__swatch--unavailable', !value);
    }

    syncPrice(html, sectionId) {
      if (!this.priceTarget || !sectionId) return;
      const source =
        html?.getElementById(`price-${sectionId}`) ||
        document.getElementById(`price-${sectionId}`);
      if (source) this.priceTarget.innerHTML = source.innerHTML;
    }

    syncMedia(variant) {
      const src = variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
      if (!this.mediaImage || !src) return;
      this.mediaImage.removeAttribute('srcset');
      this.mediaImage.src = `${src}${src.includes('?') ? '&' : '?'}width=360`;
    }

    /* Label and availability are copied from the real button so pre-order, sold out and
       unavailable states stay in one place instead of being reimplemented here. */
    syncSubmitState(html, sectionId) {
      if (!this.submitButton) return;

      const source =
        (sectionId && html?.getElementById(`ProductSubmitButton-${sectionId}`)) ||
        this.mainSubmitButton;
      if (!source) return;

      const disabled =
        source.hasAttribute('disabled') || source.getAttribute('aria-disabled') === 'true';
      this.submitButton.toggleAttribute('disabled', disabled);

      const label = source.querySelector('span')?.textContent.trim();
      if (label && this.submitText) this.submitText.textContent = label;
    }
  }

  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  class UgcVideos extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.ugc-videos__slider');
      this.cards = Array.from(this.querySelectorAll('.ugc-videos__card'));
      this.swiper = null;

      this.onSurfaceClick = this.onSurfaceClick.bind(this);
      this.onVideoStateChange = this.onVideoStateChange.bind(this);

      this.cards.forEach((card) => {
        card.querySelector('[data-ugc-toggle]')?.addEventListener('click', this.onSurfaceClick);

        const video = card.querySelector('video');
        if (!video) return;
        video.addEventListener('play', this.onVideoStateChange);
        video.addEventListener('pause', this.onVideoStateChange);
        video.addEventListener('ended', this.onVideoStateChange);
      });

      this.whenSwiperReady().then(() => {
        if (this.isConnected) this.initSwiper();
      });
    }

    disconnectedCallback() {
      this.cards.forEach((card) => {
        card.querySelector('[data-ugc-toggle]')?.removeEventListener('click', this.onSurfaceClick);

        const video = card.querySelector('video');
        if (!video) return;
        video.removeEventListener('play', this.onVideoStateChange);
        video.removeEventListener('pause', this.onVideoStateChange);
        video.removeEventListener('ended', this.onVideoStateChange);
      });

      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    /* Swiper is a deferred global script; it normally executes before this bundle,
       but resolve defensively rather than assume the order. */
    whenSwiperReady() {
      if (typeof window.Swiper !== 'undefined') return Promise.resolve();

      return new Promise((resolve) => {
        const start = performance.now();
        const poll = () => {
          if (typeof window.Swiper !== 'undefined' || performance.now() - start > 5000) {
            resolve();
            return;
          }
          requestAnimationFrame(poll);
        };
        poll();
      });
    }

    onSurfaceClick(event) {
      const card = event.currentTarget.closest('.ugc-videos__card');
      const video = card?.querySelector('video');
      if (!video) return;

      if (video.paused) {
        this.pauseAll(video);
        /* Browsers reject unmuted autoplay-adjacent playback in some contexts;
           fall back to a muted play rather than leaving a dead button. */
        video.play().catch(() => {
          video.muted = true;
          video.play().catch(() => {});
        });
      } else {
        video.pause();
      }
    }

    onVideoStateChange(event) {
      const video = event.currentTarget;
      const card = video.closest('.ugc-videos__card');
      if (!card) return;

      const isPlaying = !video.paused;
      card.dataset.playing = String(isPlaying);
      if (isPlaying) card.dataset.started = 'true';

      const surface = card.querySelector('[data-ugc-toggle]');
      if (!surface) return;

      surface.setAttribute('aria-pressed', String(isPlaying));
      const { labelPlay, labelPause } = this.dataset;
      surface.setAttribute('aria-label', isPlaying ? labelPause || '' : labelPlay || '');
    }

    pauseAll(except) {
      this.querySelectorAll('video').forEach((video) => {
        if (video !== except) video.pause();
      });
    }

    initSwiper() {
      if (!this.slider || this.swiper || typeof window.Swiper === 'undefined') return;

      const { slidesDesktop, slidesDesktopSm, slidesTablet, slidesMobile, spaceDesktop, spaceMobile } = this.dataset;

      /* `Number(x) || fallback` would swallow a deliberate 0 gap. */
      const num = (value, fallback) => {
        const parsed = Number(value);
        return value === '' || value == null || Number.isNaN(parsed) ? fallback : parsed;
      };

      const gapDesktop = num(spaceDesktop, 32);

      this.swiper = new window.Swiper(this.slider, {
        slidesPerView: num(slidesMobile, 1.5),
        spaceBetween: num(spaceMobile, 12),
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector('.ugc-videos__arrow--prev'),
          nextEl: this.querySelector('.ugc-videos__arrow--next'),
          disabledClass: 'swiper-button-disabled',
        },
        pagination: {
          el: this.querySelector('.ugc-videos__progress'),
          type: 'progressbar',
        },
        breakpoints: {
          750: {
            slidesPerView: num(slidesTablet, 2),
            spaceBetween: gapDesktop,
          },
          990: {
            slidesPerView: num(slidesDesktopSm, 3),
            spaceBetween: gapDesktop,
          },
          1200: {
            slidesPerView: num(slidesDesktop, 4),
            spaceBetween: gapDesktop,
          },
        },
        on: {
          /* Never leave a video playing on a slide the visitor scrolled away from. */
          slideChange: () => this.pauseAll(),
        },
      });
    }
  }

  if (!customElements.get('ugc-videos')) {
    customElements.define('ugc-videos', UgcVideos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  /* Puts the slider arrows on the same line as the product card title.

     CSS cannot express this on its own: the bar is a sibling of .swiper-wrapper,
     so it has no positional relationship to .product-card__title, and the offset
     cannot be derived either — the card media aspect ratio is a merchant setting
     that can be "auto". Measuring is the only thing that holds for every ratio and
     for cards with or without vendor, badges or swatches. */
  class ShopTheLookArrows extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('shop-the-look__bottom--beside-title')) return;

      this.swiper = this.closest('.swiper');
      if (!this.swiper) return;

      this.observer = new ResizeObserver(() => this.updatePosition());
      this.observer.observe(this.swiper);

      // an image that arrives late changes the title's offset
      this.swiper.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', this.updatePosition, { once: true });
      });

      this.updatePosition();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    /* Named updatePosition rather than position: a bare `position` on an element is
       one typo away from reading as a style concern. */
    updatePosition = () => {
      // Slides are height-synced by card-product-slider.js, so the first one is
      // representative and stays correct as the slider moves.
      const title = this.swiper.querySelector('.swiper-slide .product-card__title');
      if (!title) return;

      const titleBox = title.getBoundingClientRect();
      const swiperBox = this.swiper.getBoundingClientRect();
      if (!titleBox.height) return;

      const centre = titleBox.top - swiperBox.top + titleBox.height / 2;
      this.style.setProperty('--stl-arrows-top', Math.round(centre - this.offsetHeight / 2) + 'px');
    };
  }

  if (!customElements.get('shop-the-look-arrows')) {
    customElements.define('shop-the-look-arrows', ShopTheLookArrows);
  }

  } catch(e) { console.error(e); }
})();
})();
